import { render, staticRenderFns } from "./ContentTypeButton.vue?vue&type=template&id=50efe823&"
import script from "./ContentTypeButton.vue?vue&type=script&lang=js&"
export * from "./ContentTypeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports